import { createI18n } from '@learnforge/i18n';
import { locales, type GeometryKey } from './locales';

export const i18n = createI18n<GeometryKey>({
  gameId: '2d-geometry',
  locales,
});
